import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBlub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M40 20v2M22 40h-2m7-13-1.2-1.2M53 27l1.2-1.2M60 40h-2m-22 3h8m-4 0v10m7-3.252c3.028-2.178 5-5.733 5-9.748 0-6.627-5.373-12-12-12s-12 5.373-12 12c0 4.015 1.972 7.57 5 9.748V53.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C36.04 60 37.16 60 39.4 60h1.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C47 56.96 47 55.84 47 53.6z"
    />
  </svg>
);
export default SvgBlub;
